// extracted by mini-css-extract-plugin
module.exports = {"activities":"activities_activities__E96Ff"};